import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	beforeLoad: async ({ context }) => {
		if (context.session.user) {
			throw redirect({ to: "/manager" });
		}

		throw redirect({ to: "/auth/login" });
	},
});
